export const openCalendly = () => {
  if (window["open_calendly_widget"]) {
    window["open_calendly_widget"]();
  }
};
